(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['__config', '$scope', '$location', '$window', 'Principal', 'LoginService', '$state', 'CompanyInfoQuery', 'DeviceService', '$localStorage'];

    function HomeController(__config, $scope, $location, $window, Principal, LoginService, $state, CompanyInfoQuery, DeviceService, $localStorage) {
        var vm = this;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.gotoWebSite = gotoWebSite;
        vm.getAccount = getAccount;
        vm.__config = __config;
        vm.logoSource = "content/images/planovin-farsi.jpg";
        vm.referralCode = ''

        loadCompanyInfo();


        $scope.$on('authenticationSuccess', function () {

            getAccount();
        });
        $scope.$on('Logout', function () {

            vm.company = null;
        });

        // getAccount();


        function getAccount() {


            Principal.identity().then(function (account) {

                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }

        function register() {
            $state.go('register');
        }

        function loadCompanyInfo() {

            setLogoPath();

            if (Principal.isAuthenticated()) {
                CompanyInfoQuery.getCurrentCompanyInfo().get(function (company) {

                    var path = $location.path();
                    if (path == '/' && company) {
                        // $window.location.href = '/#/supplierPanel/dashboard';
                        if (company.appVersion && company.appVersion == 'v3')
                            $state.go('supplierPanel-v2.dashboard');
                        else
                            $state.go('supplierPanel.dashboard');
                        return;
                    }

                    if (company != null && company != undefined) {
                        vm.company = company;
                        if (vm.company && vm.company.keyUrl)
                            vm.websiteUrl = vm.company.keyUrl + '.reserweb.ir';
                        else
                            vm.websiteUrl = '----------------' + '.reserweb.ir';


                    } else {
                        vm.websiteUrl = '----------------' + '.reserweb.ir';
                    }

                })
            }
        }

        function gotoWebSite() {
            if (vm.company && vm.company.keyUrl) {

                window.open('http://' + vm.websiteUrl, '_blank');
            } else {
                alert('اطلاعات کسب و کار بطور کامل وارد نشده است (قدم اول را انجام دهید)');
            }
        }

        function setLogoPath() {


            if (vm.__config.appMode == 'event') {
                vm.logoSource = "content/images/wd-farsi-logo2.png"
            }
            if (vm.__config.appName && vm.__config.appName == 'planovin') {
                vm.logoSource = "content/images/planovin-farsi.jpg"
            }
        }

        function findTypeOfUserDevice() {
            if($localStorage.isNativeApp == "true"){
                vm.referralCode = "android"
            }
        }
        findTypeOfUserDevice()
    }
})();
